import { Component, OnInit } from '@angular/core';
import { I18nService } from '@app/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@app/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '@app/user.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import * as signalR from '@aspnet/signalr';
import { Observable } from 'rxjs';

declare var $: any, moment: any
@Component({
  selector: 'app-mainmenu',
  templateUrl: './mainmenu.component.html',
  styleUrls: ['./mainmenu.component.scss']
})
export class MainmenuComponent implements OnInit {

  menuStr: any;
  member_info: any;
  IsSelect: any;
  newsList: any = [];
  role: any = {}
  cookieData: any

  dpa_name = ""

  config: any

  dict: any = {}

  totalSocial = ""
  totalChatbot = ""

  intervalId: any

  constructor(
    private i18nService: I18nService,
    private titleService: Title,
    private Auth: AuthService,
    private router: Router,
    private user: UserService,
    private util: UtilService,
    private apiService: ApiService
  ) {
    router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationEnd) {
        this.InitText(val.url);
      }

    });
  }

  async ngOnInit() {
    const thisTs = this
    let ck: any = JSON.parse(localStorage.getItem("dpa_cc"))
    if (ck == null) {
      localStorage.setItem("dpa_cc", "{}")
      this.cookieData = {}
    }
    else {
      this.cookieData = ck
    }
    //document.body.className = 'sidebar-mini accent-danger';
    //loadTree();

    //signalr

    // let notiUrl = await thisTs.apiService.getNotiApiUrl()
    // const connection = new signalR.HubConnectionBuilder()
    //   .configureLogging(signalR.LogLevel.Information)
    //   .withUrl(notiUrl.toString())
    //   .build();

    // connection.start().then(function () {
    //   console.log('Connected!');
    // }).catch(function (err) {
    //   return console.error(err.toString());
    // });

    // connection.on("BroadcastMessage", (type: string, payload: string) => {
    //   console.log("type: " + type + ", payload: " + payload)
    // });

    //end signal r

    await this.getConfig()

    this.dpa_name = this.cookieData.dpa_name

    this.getNotiAndNews()
    this.intervalId = setInterval(() => {
      thisTs.getNotiAndNews()
    }, 7000)
    

    //let qsParam = "?date_start=" + moment().subtract(1, 'years').format("YYYY-MM-DD") + "&date_end=" + moment().format("YYYY-MM-DD")

    //this.genNews()

    //$('[data-provide="datepicker"]').after('<i class="fa fa-calendar" style="color: var(--cust-blue)" aria-hidden="true"></i>');
    $('[data-provide="datepicker"]').attr('placeholder', 'DD/MM/YYYY');
    
    $('.modal').on("hidden.bs.modal", function (e: any) {
      if ($('.modal:visible').length) {
        $('.modal-backdrop').first().css('z-index', parseInt($('.modal:visible').last().css('z-index')) - 10);
        $('body').addClass('modal-open');
      }
    }).on("show.bs.modal", function (e: any) {
      if ($('.modal:visible').length) {
        $('.modal-backdrop.in').first().css('z-index', parseInt($('.modal:visible').last().css('z-index')) + 10);
        $(this).css('z-index', parseInt($('.modal-backdrop.in').first().css('z-index')) + 10);
      }
    });

    $(".user-menu").on("click", function () {
      thisTs.router.navigate(["/mainmenu/" + this.id])
    });

  }

  InitText(urlpath: string) {
    const thisTs = this
    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    if(this.cookieData != null && this.cookieData.role != null){
      this.role = JSON.parse(this.cookieData.role)
    }

    setTimeout(() => {
      //clear active tab menu
      thisTs.ClaerActiveTabMenu()
      //--set active menu
      var targetUrlArray = urlpath.split("/")
      if (targetUrlArray.length > 0) {
        let id = targetUrlArray[targetUrlArray.length - 1]
        $("#" + id).prop("aria-selected", true)
        $("#" + id).addClass("active")

        $("#" + id).closest(".menu-container").addClass("menu-container-active")
      }
      //---
    }, 400);

    this.util.InitValidation()

  }

  setLanguage(language: string) {
    this.i18nService.language = language;
    this.InitLangImage();
  }

  InitLangImage() {
    var image = <HTMLImageElement>document.getElementById('imgLang');
    var res = this.i18nService.language.split('-');
    image.src = "assets/dist/img/lang/flags_iso/16/" + res[0] + ".png";
  }

  async logout() {
    var data = this.user.logout();

    if (!data.status) {

      this.Auth.setLoggedIn(false);
      this.router.navigate(['login']);

    } else {
      this.util.ErrorDialog("ออกจากระบบไม่สำเร็จ")
    }

  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  get title(): string {
    return this.titleService.getTitle();
  }

  ClaerActiveTabMenu() {
    $(".user-menu").each(function () {
      $(this).prop("aria-selected", false)
      $(this).removeClass("active")
    });

    $(".menu-container-active").each(function () {
      $(this).removeClass("menu-container-active")
      $(this).addClass("menu-container")
    })
  }

  async getConfig() {
    this.config = await this.apiService.get("master", "configuration")
    let crisisConfig: any = this.config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag == true) {
      this.cookieData.isCrisis = true
      localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))
    }
    else {
      this.cookieData.isCrisis = false
      localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))
    }
  }

  changePassword() {
    let url: string = this.util.baseUrl() + "/changePassword"
    window.open(url, "_blank")
  }

  async genNews() {

    let para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.cookieData.isCrisis.toString()
    this.newsList = await this.apiService.get("crmservice", "news", para)

    this.newsList.forEach((n: any) => {
      let news: string =
        `<a class="text-white mr-5" target="_blank" href="/news/` + n.dpa_newandactivityid + `">
          <span class="fa fa-newspaper mr-2"></span>` + n.dpa_name + `
        </a>`

      $(".marquee").append(news)
    });


    $('.marquee').marquee({
      duration: 25000,
      //gap in pixels between the tickers
      gap: 50,
      //time in milliseconds before the marquee will start animating
      delayBeforeStart: 0,
      //'left' or 'right'
      direction: 'left',
      //true or false - should the marquee be duplicated to show an effect of continues flow
      duplicated: false,

      pauseOnHover: true
    });

  }

  async getNotiAndNews(){
    let para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.cookieData.isCrisis.toString()
    Observable.forkJoin(
      this.apiService.get("crmservice", "caseIncident", "casechannelcode=04&casestatuscode=01"),
      this.apiService.get("crmservice", "caseIncident", "casechannelcode=05&casestatuscode=01"),
      this.apiService.get("crmservice", "news", para)
    ).subscribe(
      (data: any) => {
        if(data[0] != null && data[0].length > 0){
          this.totalSocial = data[0].length.toString()
        }
        else{
          this.totalSocial = ''
        }

        if(data[1] != null && data[1].length > 0){
          this.totalChatbot = data[1].length.toString()
        }
        else{
          this.totalChatbot = ''
        }

        if(this.isNewsChange(data[2] || [])){
          $(".marquee").empty()
          this.newsList.forEach((n: any) => {
            let news: string =
              `<a class="text-white mr-5" target="_blank" href="/news/` + n.dpa_newandactivityid + `">
                <span class="fa fa-newspaper mr-2"></span>` + n.dpa_name + `
              </a>`
      
            $(".marquee").append(news)
          });
      
      
          $('.marquee').marquee({
            duration: 25000,
            //gap in pixels between the tickers
            gap: 50,
            //time in milliseconds before the marquee will start animating
            delayBeforeStart: 0,
            //'left' or 'right'
            direction: 'left',
            //true or false - should the marquee be duplicated to show an effect of continues flow
            duplicated: false,
      
            pauseOnHover: true
          });
        }
        
      },
      err => {
        console.error(err)
      }
    );
  }

  isNewsChange(responseList: any){
    let newsListCount = 0
    let responseCount = 0

    if(this.newsList != null){
      newsListCount = this.newsList.length
    }
    else{
      this.newsList = []
    }
    if(responseList != null){
      responseCount = responseList.length
    }
    else{
      responseList = []
    }

    if(newsListCount != responseCount){
      this.newsList = responseList
      return true
    }

    responseList.forEach((r: any) => {
      if(this.newsList.indexOf(r) == -1){
        this.newsList = responseList
        return true
      }
    })
    
    return false
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.ts